import { useControlled } from "@mui/material";
import { useCallback, useLayoutEffect, useRef } from "react";
import { actionHeaderName } from "../classes.js";
function useHeaderState(props) {
  const { expanded: controlledExpanded, onChange, defaultExpanded } = props;
  const [expanded, setExpanded] = useControlled({
    name: actionHeaderName,
    state: "expanded",
    default: defaultExpanded,
    controlled: controlledExpanded
  });
  const ref = useRef({
    expanded,
    onChange
  });
  useLayoutEffect(() => {
    ref.current = {
      expanded,
      onChange
    };
  });
  const onOpen = useCallback(() => {
    setExpanded(true);
    ref.current.onChange?.(true);
  }, [setExpanded]);
  const onClose = useCallback(() => {
    setExpanded(false);
    ref.current.onChange?.(false);
  }, [setExpanded]);
  const onToggle = useCallback(() => {
    const next = !ref.current.expanded;
    setExpanded(next);
    ref.current.onChange?.(next);
  }, [setExpanded]);
  return {
    expanded,
    onOpen,
    onClose,
    onToggle
  };
}
export {
  useHeaderState
};
//# sourceMappingURL=useHeaderState.js.map
